import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { MessageService } from '../../_services/message.service';
import { Globals } from '../../_globals/globals';
import { BendingMachine } from '../../_models/bending_machine';

@Injectable({
  providedIn: 'root'
})
export class BendingMachineService {

  constructor(
    private http: HttpClient,
    private globals: Globals,
    private messageService: MessageService
  ) {}

  getBendingMachines(searchParams: any = null): Observable<BendingMachine[]> {
    let params = new HttpParams();
    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key) && searchParams[key] !== undefined && searchParams[key] !== null) {
          params = params.set(key, searchParams[key]);
        }
      }
    }
    return this.http.get<BendingMachine[]>(this.globals.apiUrl + '/bending_machine', { params: params })
      .pipe(
        tap(_ => this.log('get bending_machine')),
        catchError(this.handleError<BendingMachine[]>('getBendingMachines', []))
      );
  }

  updateBendingMachine(itemIn: BendingMachine): Observable<BendingMachine> {
    const idValue = itemIn && itemIn.id ? itemIn.id.toString() : '0';
    return this.http.put<BendingMachine>(this.globals.apiUrl + '/bending_machine', itemIn, {
      params: new HttpParams().set('id', idValue)
    }).pipe(
      tap(_ => this.log('updated bending_machine')),
      catchError(this.handleError<BendingMachine>('updateBendingMachine', null))
    );
  }

  createBendingMachine(itemIn: BendingMachine): Observable<BendingMachine> {
    return this.http.post<BendingMachine>(this.globals.apiUrl + '/bending_machine', itemIn, {})
      .pipe(
        tap(_ => this.log('created bending_machine')),
        catchError(this.handleError<BendingMachine>('createBendingMachine', null))
      );
  }

  deleteBendingMachine(itemIn: BendingMachine): Observable<any> {
    return this.http.delete<any>(this.globals.apiUrl + '/bending_machine', {
      params: new HttpParams().set('id', itemIn.id.toString())
    }).pipe(
      tap(_ => this.log('deleted bending_machine')),
      catchError(this.handleError<any>('deleteBendingMachine', null))
    );
  }

  private log(message: string) {
    this.messageService.add(`BendingMachineService: ${message}`);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      this.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }
}
